import { useState } from "react";

export const useMapsInstance = (initialState) => {
  const [state, setState] = useState(initialState);

  const updateMapsInstance = (google, maps) => {
    setState({
      google: google,
      maps: maps
    });
  };

  return [state, updateMapsInstance];
};